import { Injectable } from '@angular/core';
import { SecurityService, UserDetail } from '@xpo/security';
import { AppSettings } from '../models/appSettings.model';

import { AuthUserProfileService } from '@xpo/security';

import { XpoPermissionService } from '@xpo/common';

import { Observable } from 'rxjs/Observable';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AuthorizationService {
  private permissions: string[] = [];
  private hasAccessSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private securityService: SecurityService,
    private appSettings: AppSettings,
    private profileService: AuthUserProfileService,
    private permissionService: XpoPermissionService,
  ) {
    this.securityService.user
      .subscribe((userDetail) => this.onUserChanged(userDetail));
  }

  private onUserChanged(userDetail: UserDetail) {
    if (!userDetail) {
      this.permissions = [];
    } else {
      // Get User Roles
      const roles = this.profileService.getProfile(this.appSettings.appCode).subscribe(
        (userProfile) => {
          this.permissions = userProfile.permissions || [];
          this.permissionService.setPermissions(this.permissions);
        },
        (error) => {
          this.permissions = [];
          this.permissionService.setPermissions(this.permissions);
        });
    }
  }

  public hasAccess(requestedPermissions: string[]): Observable<boolean> {
    if (!requestedPermissions || requestedPermissions.length == 0) {
      return Observable.of(true);
    }

    const hasAccess = this.permissions.some((x) => requestedPermissions.includes(x));
    return Observable.of(hasAccess);
  }
}



// WEBPACK FOOTER //
// ./src/core/services/authorization.service.ts